export function encodeWKTCRS(wkt, options) {
  if (Array.isArray(wkt) && wkt.length === 1 && Array.isArray(wkt[0])) {
    wkt = wkt[0];
  }
  const [kw, ...attrs] = wkt;
  const str = `${kw}[${attrs.map(attr => {
    if (Array.isArray(attr)) {
      return encodeWKTCRS(attr, options);
    } else if (typeof attr === 'number') {
      return attr.toString();
    } else if (typeof attr === 'string') {
      if (attr.startsWith('raw:')) {
        return attr.replace('raw:', '');
      }
      return `"${attr}"`;
    }
    throw new Error(`[wktcrs] unexpected attribute "${attr}"`);
  }).join(',')}]`;
  return str;
}
//# sourceMappingURL=encode-wkt-crs.js.map